import { render, staticRenderFns } from "./MerchantApplyDialog.vue?vue&type=template&id=999d83b0"
import script from "./MerchantApplyDialog.vue?vue&type=script&lang=js"
export * from "./MerchantApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./MerchantApplyDialog.vue?vue&type=style&index=0&id=999d83b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports